import { Box, Tooltip } from "@chakra-ui/react";
import { FormControl } from "features/entities/EntityCreatePage/EntityCreatePage";
import { useCommittingEntities } from "features/entities/EntityCreatePage/EntityGraph/hooks/useCommittingEntities";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormEntitySelect } from "shared/components/input/select/FormEntitySelect";

export const InvestingEntities: React.FC<{
  control: FormControl;
  label: string;
  emptyText: string;
  onChangeValue: (newValue: string[]) => void;
}> = ({ control, label, onChangeValue }) => {
  const functionalType = useWatch({
    control,
    name: "entity_data.functional_type",
  });
  const committedEntites = useCommittingEntities();
  const { t } = useTranslation(["common", "entity"]);

  const isDisabled = !functionalType;

  const formInput = (
    <FormEntitySelect
      filter={(entity) => !committedEntites.has(entity.id!)}
      shouldUnregister={false}
      isMulti={true}
      name="investing_into_entities"
      title={label}
      isDisabled={isDisabled}
      // TODO ENG-8460 broken generic type
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onChangeValue={onChangeValue as any}
    />
  );

  if (isDisabled) {
    return (
      <Tooltip label={t("entity:create.tooltip")} placement="bottom">
        <Box>{formInput}</Box>
      </Tooltip>
    );
  }
  return <Box>{formInput}</Box>;
};
